export default "__VITE_ASSET__93f3e7b6__"